module.exports = __webpack_public_path__ + "img/Processon.703549d6.png";